import { FormHelperText } from '@mui/material';
import PropTypes from 'prop-types';

const FormErrorHelperText = ({ children, error = true, ...props }) => {
  return (
    <FormHelperText sx={{ margin: '3px 14px 0', ...props.sx }} error={error} {...props}>
      {children}
    </FormHelperText>
  );
};

FormErrorHelperText.propTypes = {
  children: PropTypes.any,
  error: PropTypes.bool,
  sx: PropTypes.object,
};

export default FormErrorHelperText;
